import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <header>
      <Link to="/" className="logo">
        <div className="logo-img" style={{backgroundImage: "url('/perodua-logo.webp')"}}></div>
      </Link>
      <nav className="nav-links">
        {isHomePage ? (
          <>
            <a href="#models">Models</a>
            <a href="#calculator">Calculator</a>
            <a href="#advisors">Sales Team</a>
            <a href="#reviews">Reviews</a>
            <a href="#contact">Contact</a>
          </>
        ) : (
          <>
            <Link to="/#models">Models</Link>
            <Link to="/#calculator">Calculator</Link>
            <Link to="/#advisors">Sales Team</Link>
            <Link to="/#reviews">Reviews</Link>
            <Link to="/#contact">Contact</Link>
          </>
        )}
      </nav>
      <div>
        <a href="tel:0358828800" className="cta-btn">Call Us (03-5882 8800)</a>
      </div>
    </header>
  );
};

export default Header;
